let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("94waC")).then(() => parcelRequire('ju82O'));